"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToUnit = stringToUnit;
exports.unitToString = unitToString;
exports.amountToString = amountToString;
exports.stringToAmount = stringToAmount;
const uom_1 = require("uom");
const unit_lookup_1 = require("./unit-lookup");
function stringToUnit(unitString) {
    return uom_1.Serialize.stringToUnit(unitString.toLowerCase(), unit_lookup_1.unitLookup);
}
function unitToString(unit) {
    return uom_1.Serialize.unitToString(unit);
}
function amountToString(amount) {
    return uom_1.Serialize.amountToString(amount);
}
function stringToAmount(amountString) {
    return uom_1.Serialize.stringToAmount(amountString.toLowerCase(), unit_lookup_1.unitLookup);
}
//# sourceMappingURL=serialize.js.map